import { render, staticRenderFns } from "./DemoShowCard.vue?vue&type=template&id=7c01c120&scoped=true"
import script from "./DemoShowCard.vue?vue&type=script&lang=ts"
export * from "./DemoShowCard.vue?vue&type=script&lang=ts"
import style0 from "./DemoShowCard.vue?vue&type=style&index=0&id=7c01c120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c01c120",
  null
  
)

export default component.exports